define("checkout/components/checkout", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "@ember/object", "@ember/service", "@glimmer/tracking", "ember-concurrency"], function (_exports, _component, _templateFactory, _component2, _object, _service, _tracking, _emberConcurrency) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;

  0; //eaimeta@70e063a35619d71f0,"@glimmer/component",0,"@ember/object",0,"@ember/service",0,"@glimmer/tracking",0,"ember-concurrency",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <Containers::LoadCheckoutData
    @planType={{@planType}}
    @onTransactionComplete={{this.handleTransactionComplete}}
    as |checkout checkoutActions proration|>
  
    {{#if this.showTrialSuccessModal}}
      <Shared::Modal @close={{this.closeTrialSuccessModal }} as |modal|>
        <modal.card @portrait={{true}} class="has--footer">
          <modal.card-header class="u--p__b">
            <h1 class="o--modalHeader__title">
              {{t "plans.checkout.trial_success.title"}}
            </h1>
          </modal.card-header>
          <modal.card-body>
            <div>
              <p class="u--text--md u--m__b">
                {{html-safe
                  (t
                    "plans.checkout.trial_success.sub_title"
                    planName=checkout.selectedSubscriptionPlan.name
                    interval=checkout.selectedSubscriptionPlan.interval
                    expiryDate=(moment-format checkout.currentAccount.trialExpiryMoment "MMM DD, YYYY")
                  )
                }}
              </p>
            </div>
          </modal.card-body>
          <modal.card-footer>
            <Shared::Ui::Button
                type="submit"
                @size="large"
                @additional="block"
                @text={{t "plans.checkout.trial_success.button_calendar"}}
                @onClick={{@onTrialSuccessButton}}
              />
          </modal.card-footer>
        </modal.card>
      </Shared::Modal>
    {{else}}
      <Shared::Modal @close={{(fn this.closeCheckoutModal.perform (or checkout.hasCheckoutChanges this.isEditingAddress))}} as |modal|>
        <modal.card @portrait={{false}} class="tPF--modalCard">
          <modal.card-body class="u--p__0">
            {{#if checkout.isReady}}
              <div class="{{concat "tCH--plan--" @planType}} tPF--checkoutWrapper">
                <div class="tPF--checkout--details">
                  <h2 class="tPF--checkout__title">
                    {{#if @onBackButtonClick}}
                      <Shared::Ui::Button
                        class="u--text--hair u--text--light u--block u--p__0 u--m__b"
                        @type="none"
                        @onClick={{@onBackButtonClick}}
                      >
                        {{svg-jar "nav-left" class="o--icon"}}
                        <span>{{t "plans.view_all_plans"}}</span>
                      </Shared::Ui::Button>
                    {{/if}}
                    {{t
                      "plans.checkout.title_trial"
                      planName=checkout.planName
                      htmlSafe=true
                    }}
                    <span {{on "click" this.toggleAllFeaturesModal}}>
                      {{svg-jar "info" class="o--icon--md tCH--text--highlight u--cursor"}}
                      <span class="u--screen-reader">{{t "plans.see_all_features"}}</span>
                    </span>
                  </h2>
                  <Interval
                    @monthlyPlan={{checkout.monthlyPlan}}
                    @displayMonthly={{this.canSelectMonthlyInterval}}
                    @yearlyPlan={{checkout.yearlyPlan}}
                    @selectedSubscriptionPlan={{checkout.selectedSubscriptionPlan}}
                    @onInterval={{checkoutActions.handleInterval}}
                    @isHorizontal={{true}}
                  />
                  <SeamlessCheckoutTable
                    @additionalTeamMemberCount={{checkout.additionalTeamMemberCount}}
                    @additionalSocialSetCount={{checkout.additionalSocialSetCount}}
                    @canAddons={{checkout.canAddons}}
                    @coupon={{checkout.coupon}}
                    @discount={{checkout.discount}}
                    @initialTeamMemberCount={{checkout.initialTeamMemberCount}}
                    @initialSocialSetCount={{checkout.initialSocialSetCount}}
                    @isMonthly={{checkout.isMonthly}}
                    @onTeamMemberChange={{checkoutActions.handleTeamMemberChange}}
                    @onSocialSetChange={{checkoutActions.handleSocialSetChange}}
                    @proration={{proration}}
                    @selectedSubscriptionPlan={{checkout.selectedSubscriptionPlan}}
                    @totalCost={{checkout.totalCost}}
                    @totalSocialSetCost={{checkout.totalSocialSetCost}}
                    @totalTeamMemberCost={{checkout.totalTeamMemberCost}}
                  />
                  {{!-- Note: When checkout is for more than trial starts, the ChargesSummary component may be helpful --}}
                  <Payment::Coupon
                    @selectedSubscriptionPlan={{checkout.selectedSubscriptionPlan}}
                    @onCoupon={{checkoutActions.handleCoupon}}
                  />
                  {{#if (or checkout.isEligibleForTrial checkout.hasActiveTrial)}}
                    {{!-- Total Today --}}
                    <table class="o--table o--table--condensed tPF--checkout__tr--border u--text--md u--text--bold u--text--success u--m__b__0">
                      <tbody>
                        <tr>
                          <td><span data-test-id="trial-amount">{{t "plans.checkout.plan.trial_total_today_days_free"}}</span></td>
                          <td><span class="u--float--right u--text--lg ">{{t "plans.checkout.plan.trial_total_amount"}}</span></td>
                        </tr>
                      </tbody>
                    </table>
                  {{/if}}
                </div>
  
                {{!-- Payment Details --}}
                <div class="tPF--checkout--payment">
                  <p class="u--text--md u--text tCH--text--highlight">
                    {{t "plans.checkout.plan.step_2"}}
                  </p>
                  <Payment::Card
                    @onCard={{action checkoutActions.handleStripeCard}}
                    @isCardEmpty={{checkout.hasEmptyCard}}
                  />
                  <Payment::Address
                    @isEditingAddress={{this.isEditingAddress}}
                    @hideEditingAddress={{this.hideEditingAddress}}
                    @setEditingAddress={{this.setEditingAddress}}
                  />
  
                  <div class="tPF--checkout__footer">
                    <CheckoutButton
                      @cardState={{checkout.card.state}}
                      @isEditingAddress={{this.isEditingAddress}}
                      @isSamePlan={{checkout.isSamePlan}}
                      @isSameInterval={{checkout.isSameInterval}}
                      @hasActiveSubscription={{checkout.hasActiveSubscription}}
                      @isEligibleForTrial={{checkout.isEligibleForTrial}}
                      @hasAgencyPlanCheckoutRestrictions={{false}}
                      @hasActiveTrial={{checkout.hasActiveTrial}}
                      @hasActiveCancelledSubscription={{false}}
                      @hasAddonChange={{checkout.hasAddonChange}}
                      @onCheckout={{checkoutActions.handleCheckout}}
                      @onChangePlan={{checkoutActions.handleChangePlan}}
                      @onChangeCard={{checkoutActions.handleStripeCardChange}}
                      @showMissingInfoMesage={{false}}
                    />
                    <div class="u--text--light u--p__t__sm qa--checkout__summary--secure">
                      {{svg-jar "lock" class="o--icon u--m__r__xs"}}
                      {{t "plans.checkout.plan.summary_secure"}}
                    </div>
                  </div>
                </div>
              </div>
            {{/if}}
          </modal.card-body>
        </modal.card>
      </Shared::Modal>
    {{/if}}
  
    {{#if this.showAllFeaturesModal}}
      <Shared::Upgrade::AllFeaturesModal
        @plan={{checkout.plan}}
        @isMonthly={{checkout.isMonthly}}
        @close={{this.toggleAllFeaturesModal}}
      />
    {{/if}}
  </Containers::LoadCheckoutData>
  
  */
  {
    "id": "woG7rFDH",
    "block": "[[[8,[39,0],null,[[\"@planType\",\"@onTransactionComplete\"],[[30,1],[30,0,[\"handleTransactionComplete\"]]]],[[\"default\"],[[[[1,\"\\n\\n\"],[41,[30,0,[\"showTrialSuccessModal\"]],[[[1,\"    \"],[8,[39,2],null,[[\"@close\"],[[30,0,[\"closeTrialSuccessModal\"]]]],[[\"default\"],[[[[1,\"\\n      \"],[8,[30,5,[\"card\"]],[[24,0,\"has--footer\"]],[[\"@portrait\"],[true]],[[\"default\"],[[[[1,\"\\n        \"],[8,[30,5,[\"card-header\"]],[[24,0,\"u--p__b\"]],null,[[\"default\"],[[[[1,\"\\n          \"],[10,\"h1\"],[14,0,\"o--modalHeader__title\"],[12],[1,\"\\n            \"],[1,[28,[35,3],[\"plans.checkout.trial_success.title\"],null]],[1,\"\\n          \"],[13],[1,\"\\n        \"]],[]]]]],[1,\"\\n        \"],[8,[30,5,[\"card-body\"]],null,null,[[\"default\"],[[[[1,\"\\n          \"],[10,0],[12],[1,\"\\n            \"],[10,2],[14,0,\"u--text--md u--m__b\"],[12],[1,\"\\n              \"],[1,[28,[35,4],[[28,[37,3],[\"plans.checkout.trial_success.sub_title\"],[[\"planName\",\"interval\",\"expiryDate\"],[[30,2,[\"selectedSubscriptionPlan\",\"name\"]],[30,2,[\"selectedSubscriptionPlan\",\"interval\"]],[28,[37,5],[[30,2,[\"currentAccount\",\"trialExpiryMoment\"]],\"MMM DD, YYYY\"],null]]]]],null]],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"]],[]]]]],[1,\"\\n        \"],[8,[30,5,[\"card-footer\"]],null,null,[[\"default\"],[[[[1,\"\\n          \"],[8,[39,6],[[24,4,\"submit\"]],[[\"@size\",\"@additional\",\"@text\",\"@onClick\"],[\"large\",\"block\",[28,[37,3],[\"plans.checkout.trial_success.button_calendar\"],null],[30,6]]],null],[1,\"\\n        \"]],[]]]]],[1,\"\\n      \"]],[]]]]],[1,\"\\n    \"]],[5]]]]],[1,\"\\n\"]],[]],[[[1,\"    \"],[8,[39,2],null,[[\"@close\"],[[28,[37,7],[[30,0,[\"closeCheckoutModal\",\"perform\"]],[28,[37,8],[[30,2,[\"hasCheckoutChanges\"]],[30,0,[\"isEditingAddress\"]]],null]],null]]],[[\"default\"],[[[[1,\"\\n      \"],[8,[30,7,[\"card\"]],[[24,0,\"tPF--modalCard\"]],[[\"@portrait\"],[false]],[[\"default\"],[[[[1,\"\\n        \"],[8,[30,7,[\"card-body\"]],[[24,0,\"u--p__0\"]],null,[[\"default\"],[[[[1,\"\\n\"],[41,[30,2,[\"isReady\"]],[[[1,\"            \"],[10,0],[15,0,[29,[[28,[37,9],[\"tCH--plan--\",[30,1]],null],\" tPF--checkoutWrapper\"]]],[12],[1,\"\\n              \"],[10,0],[14,0,\"tPF--checkout--details\"],[12],[1,\"\\n                \"],[10,\"h2\"],[14,0,\"tPF--checkout__title\"],[12],[1,\"\\n\"],[41,[30,8],[[[1,\"                    \"],[8,[39,6],[[24,0,\"u--text--hair u--text--light u--block u--p__0 u--m__b\"]],[[\"@type\",\"@onClick\"],[\"none\",[30,8]]],[[\"default\"],[[[[1,\"\\n                      \"],[1,[28,[35,10],[\"nav-left\"],[[\"class\"],[\"o--icon\"]]]],[1,\"\\n                      \"],[10,1],[12],[1,[28,[35,3],[\"plans.view_all_plans\"],null]],[13],[1,\"\\n                    \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"                  \"],[1,[28,[35,3],[\"plans.checkout.title_trial\"],[[\"planName\",\"htmlSafe\"],[[30,2,[\"planName\"]],true]]]],[1,\"\\n                  \"],[11,1],[4,[38,11],[\"click\",[30,0,[\"toggleAllFeaturesModal\"]]],null],[12],[1,\"\\n                    \"],[1,[28,[35,10],[\"info\"],[[\"class\"],[\"o--icon--md tCH--text--highlight u--cursor\"]]]],[1,\"\\n                    \"],[10,1],[14,0,\"u--screen-reader\"],[12],[1,[28,[35,3],[\"plans.see_all_features\"],null]],[13],[1,\"\\n                  \"],[13],[1,\"\\n                \"],[13],[1,\"\\n                \"],[8,[39,12],null,[[\"@monthlyPlan\",\"@displayMonthly\",\"@yearlyPlan\",\"@selectedSubscriptionPlan\",\"@onInterval\",\"@isHorizontal\"],[[30,2,[\"monthlyPlan\"]],[30,0,[\"canSelectMonthlyInterval\"]],[30,2,[\"yearlyPlan\"]],[30,2,[\"selectedSubscriptionPlan\"]],[30,3,[\"handleInterval\"]],true]],null],[1,\"\\n                \"],[8,[39,13],null,[[\"@additionalTeamMemberCount\",\"@additionalSocialSetCount\",\"@canAddons\",\"@coupon\",\"@discount\",\"@initialTeamMemberCount\",\"@initialSocialSetCount\",\"@isMonthly\",\"@onTeamMemberChange\",\"@onSocialSetChange\",\"@proration\",\"@selectedSubscriptionPlan\",\"@totalCost\",\"@totalSocialSetCost\",\"@totalTeamMemberCost\"],[[30,2,[\"additionalTeamMemberCount\"]],[30,2,[\"additionalSocialSetCount\"]],[30,2,[\"canAddons\"]],[30,2,[\"coupon\"]],[30,2,[\"discount\"]],[30,2,[\"initialTeamMemberCount\"]],[30,2,[\"initialSocialSetCount\"]],[30,2,[\"isMonthly\"]],[30,3,[\"handleTeamMemberChange\"]],[30,3,[\"handleSocialSetChange\"]],[30,4],[30,2,[\"selectedSubscriptionPlan\"]],[30,2,[\"totalCost\"]],[30,2,[\"totalSocialSetCost\"]],[30,2,[\"totalTeamMemberCost\"]]]],null],[1,\"\\n\"],[1,\"                \"],[8,[39,14],null,[[\"@selectedSubscriptionPlan\",\"@onCoupon\"],[[30,2,[\"selectedSubscriptionPlan\"]],[30,3,[\"handleCoupon\"]]]],null],[1,\"\\n\"],[41,[28,[37,8],[[30,2,[\"isEligibleForTrial\"]],[30,2,[\"hasActiveTrial\"]]],null],[[[1,\"                  \"],[10,\"table\"],[14,0,\"o--table o--table--condensed tPF--checkout__tr--border u--text--md u--text--bold u--text--success u--m__b__0\"],[12],[1,\"\\n                    \"],[10,\"tbody\"],[12],[1,\"\\n                      \"],[10,\"tr\"],[12],[1,\"\\n                        \"],[10,\"td\"],[12],[10,1],[14,\"data-test-id\",\"trial-amount\"],[12],[1,[28,[35,3],[\"plans.checkout.plan.trial_total_today_days_free\"],null]],[13],[13],[1,\"\\n                        \"],[10,\"td\"],[12],[10,1],[14,0,\"u--float--right u--text--lg \"],[12],[1,[28,[35,3],[\"plans.checkout.plan.trial_total_amount\"],null]],[13],[13],[1,\"\\n                      \"],[13],[1,\"\\n                    \"],[13],[1,\"\\n                  \"],[13],[1,\"\\n\"]],[]],null],[1,\"              \"],[13],[1,\"\\n\\n\"],[1,\"              \"],[10,0],[14,0,\"tPF--checkout--payment\"],[12],[1,\"\\n                \"],[10,2],[14,0,\"u--text--md u--text tCH--text--highlight\"],[12],[1,\"\\n                  \"],[1,[28,[35,3],[\"plans.checkout.plan.step_2\"],null]],[1,\"\\n                \"],[13],[1,\"\\n                \"],[8,[39,15],null,[[\"@onCard\",\"@isCardEmpty\"],[[28,[37,16],[[30,0],[30,3,[\"handleStripeCard\"]]],null],[30,2,[\"hasEmptyCard\"]]]],null],[1,\"\\n                \"],[8,[39,17],null,[[\"@isEditingAddress\",\"@hideEditingAddress\",\"@setEditingAddress\"],[[30,0,[\"isEditingAddress\"]],[30,0,[\"hideEditingAddress\"]],[30,0,[\"setEditingAddress\"]]]],null],[1,\"\\n\\n                \"],[10,0],[14,0,\"tPF--checkout__footer\"],[12],[1,\"\\n                  \"],[8,[39,18],null,[[\"@cardState\",\"@isEditingAddress\",\"@isSamePlan\",\"@isSameInterval\",\"@hasActiveSubscription\",\"@isEligibleForTrial\",\"@hasAgencyPlanCheckoutRestrictions\",\"@hasActiveTrial\",\"@hasActiveCancelledSubscription\",\"@hasAddonChange\",\"@onCheckout\",\"@onChangePlan\",\"@onChangeCard\",\"@showMissingInfoMesage\"],[[30,2,[\"card\",\"state\"]],[30,0,[\"isEditingAddress\"]],[30,2,[\"isSamePlan\"]],[30,2,[\"isSameInterval\"]],[30,2,[\"hasActiveSubscription\"]],[30,2,[\"isEligibleForTrial\"]],false,[30,2,[\"hasActiveTrial\"]],false,[30,2,[\"hasAddonChange\"]],[30,3,[\"handleCheckout\"]],[30,3,[\"handleChangePlan\"]],[30,3,[\"handleStripeCardChange\"]],false]],null],[1,\"\\n                  \"],[10,0],[14,0,\"u--text--light u--p__t__sm qa--checkout__summary--secure\"],[12],[1,\"\\n                    \"],[1,[28,[35,10],[\"lock\"],[[\"class\"],[\"o--icon u--m__r__xs\"]]]],[1,\"\\n                    \"],[1,[28,[35,3],[\"plans.checkout.plan.summary_secure\"],null]],[1,\"\\n                  \"],[13],[1,\"\\n                \"],[13],[1,\"\\n              \"],[13],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]],null],[1,\"        \"]],[]]]]],[1,\"\\n      \"]],[]]]]],[1,\"\\n    \"]],[7]]]]],[1,\"\\n\"]],[]]],[1,\"\\n\"],[41,[30,0,[\"showAllFeaturesModal\"]],[[[1,\"    \"],[8,[39,19],null,[[\"@plan\",\"@isMonthly\",\"@close\"],[[30,2,[\"plan\"]],[30,2,[\"isMonthly\"]],[30,0,[\"toggleAllFeaturesModal\"]]]],null],[1,\"\\n\"]],[]],null]],[2,3,4]]]]],[1,\"\\n\"]],[\"@planType\",\"checkout\",\"checkoutActions\",\"proration\",\"modal\",\"@onTrialSuccessButton\",\"modal\",\"@onBackButtonClick\"],false,[\"containers/load-checkout-data\",\"if\",\"shared/modal\",\"t\",\"html-safe\",\"moment-format\",\"shared/ui/button\",\"fn\",\"or\",\"concat\",\"svg-jar\",\"on\",\"interval\",\"seamless-checkout-table\",\"payment/coupon\",\"payment/card\",\"action\",\"payment/address\",\"checkout-button\",\"shared/upgrade/all-features-modal\"]]",
    "moduleName": "checkout/components/checkout.hbs",
    "isStrictMode": false
  });

  let Checkout = (_class = class Checkout extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "address", _descriptor, this);

      _initializerDefineProperty(this, "dialogManager", _descriptor2, this);

      _initializerDefineProperty(this, "intl", _descriptor3, this);

      _initializerDefineProperty(this, "plans", _descriptor4, this);

      _initializerDefineProperty(this, "isEditingAddress", _descriptor5, this);

      _initializerDefineProperty(this, "showTrialSuccessModal", _descriptor6, this);

      _initializerDefineProperty(this, "showAllFeaturesModal", _descriptor7, this);

      _defineProperty(this, "isEligibleForTrial", true);
    }

    get canSelectMonthlyInterval() {
      return this.plans.canSelectMonthlyInterval;
    }

    closeTrialSuccessModal() {
      var _this$args;

      (_this$args = this.args) === null || _this$args === void 0 ? void 0 : _this$args.onClose();
    }

    hideEditingAddress() {
      this.isEditingAddress = false;
    }

    setEditingAddress() {
      this.isEditingAddress = true;
    }

    handleTransactionComplete() {
      this.showTrialSuccessModal = true;
    }

    toggleAllFeaturesModal() {
      this.showAllFeaturesModal = !this.showAllFeaturesModal;
    }

    *goBack() {
      var _this$args2;

      let hasChanges = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (hasChanges) {
        const didConfirm = yield this.dialogManager.confirmation(this.intl.t('shared_phrases.close_warning'), {
          description: this.intl.t('shared_phrases.your_changes_not_saved'),
          confirmButton: this.intl.t('shared_words.leave')
        });

        if (!didConfirm) {
          return;
        }
      }

      (_this$args2 = this.args) === null || _this$args2 === void 0 ? void 0 : _this$args2.onBackButtonClick();
    }

    *closeCheckoutModal() {
      var _this$args3;

      let hasChanges = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (hasChanges) {
        const didConfirm = yield this.dialogManager.confirmation(this.intl.t('shared_phrases.close_warning'), {
          description: this.intl.t('shared_phrases.your_changes_not_saved'),
          confirmButton: this.intl.t('shared_words.leave')
        });

        if (!didConfirm) {
          return;
        }
      }

      (_this$args3 = this.args) === null || _this$args3 === void 0 ? void 0 : _this$args3.onClose();
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "address", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "dialogManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "plans", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "isEditingAddress", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "showTrialSuccessModal", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "showAllFeaturesModal", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "closeTrialSuccessModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "closeTrialSuccessModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hideEditingAddress", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "hideEditingAddress"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setEditingAddress", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "setEditingAddress"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleTransactionComplete", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleTransactionComplete"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleAllFeaturesModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleAllFeaturesModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "goBack", [_emberConcurrency.task], Object.getOwnPropertyDescriptor(_class.prototype, "goBack"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeCheckoutModal", [_emberConcurrency.task], Object.getOwnPropertyDescriptor(_class.prototype, "closeCheckoutModal"), _class.prototype)), _class);
  _exports.default = Checkout;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, Checkout);
});